var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowProfit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.846667L0.853333 0L12 11.1467L11.1533 12L8.70667 9.55333C8.29333 10 7.69333 10.3667 7 10.5467V12H5V10.5467C3.64667 10.2067 2.66667 9.19333 2.66667 8H4C4 8.72 4.91333 9.33333 6 9.33333C6.75333 9.33333 7.42667 9.04 7.76667 8.61333L5.78667 6.63333C4.38667 6.28 2.66667 5.83333 2.66667 4C2.66667 3.84667 2.66667 3.7 2.71333 3.56L0 0.846667ZM5 1.45333V0H7V1.45333C8.35333 1.79333 9.33333 2.80667 9.33333 4H8C8 3.28 7.08667 2.66667 6 2.66667C5.75333 2.66667 5.52 2.7 5.3 2.75333L4.26667 1.72L5 1.45333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowProfit);
export default __webpack_public_path__ + "static/media/lowProfit.4f6bb8b8.svg";
export { ForwardRef as ReactComponent };